module.exports = __webpack_public_path__ + "img/devicelteid.e11e2c2c.png";